export const CONVERT_CASE_FROM = {
    SNAKE: (snake) => snake.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()),
};

export function convertObjectKeysToCamelCase(obj, convertFromFn = CONVERT_CASE_FROM.SNAKE) {
    if (!obj) return;
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [convertFromFn(key), value]));
}
